import { CihSectionHeader } from "~/components/cih/section-header";
import { MarkdownContent } from "~/components/markdown-content";

type Props = {
  whyTitle: string | null;
  whyContent: string | null;
  sectionNumber: number;
};

export function CoachApproachSection({
  whyTitle,
  whyContent,
  sectionNumber,
}: Props) {
  if (!whyContent?.trim()) return null;
  return (
    <section id="approach" className="border-t border-gray-200 bg-gray-100">
      <CihSectionHeader
        label={`${String(sectionNumber).padStart(2, "0")} · Approach`}
        title={whyTitle?.trim() || "How I think about this work"}
      />
      <div className="mx-auto max-w-7xl px-4 pb-14 md:pb-20 xl:px-0">
        <div className="max-w-prose text-gray-700">
          <MarkdownContent ugc content={whyContent} />
        </div>
      </div>
    </section>
  );
}
